// extracted by mini-css-extract-plugin
export default {"alertContent":"Gc336e1","alertIconWrapper":"Gb744eb","alertIcon":"Gd994b4","alertText":"G0afeec","creditCopy":"Gc7ebaa"};